import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mx-auto d-flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    color: _ctx.nodeColor,
    class: "workflow-node"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "d-flex font-weight-bold align-center text-center text-subtitle-2 py-2" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.isMainAgent)
              ? (_openBlock(), _createBlock(_component_v_icon, {
                  key: 0,
                  start: "",
                  size: "medium"
                }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createTextVNode("mdi-brain")
                  ])),
                  _: 1,
                  __: [0]
                }))
              : (_ctx.isHelperAgent)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 1,
                    start: "",
                    size: "medium"
                  }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode("mdi-account-cog")
                    ])),
                    _: 1,
                    __: [1]
                  }))
                : (_ctx.isTool)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 2,
                      start: "",
                      size: "medium"
                    }, {
                      default: _withCtx(() => _cache[2] || (_cache[2] = [
                        _createTextVNode("mdi-hammer-wrench")
                      ])),
                      _: 1,
                      __: [2]
                    }))
                  : (_ctx.isEmbedding)
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 3,
                        start: "",
                        size: "medium"
                      }, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createTextVNode("mdi-vector-polyline")
                        ])),
                        _: 1,
                        __: [3]
                      }))
                    : (_ctx.isProvider)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 4,
                          start: "",
                          size: "medium"
                        }, {
                          default: _withCtx(() => _cache[4] || (_cache[4] = [
                            _createTextVNode("mdi-cloud-outline")
                          ])),
                          _: 1,
                          __: [4]
                        }))
                      : (_ctx.isServer)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 5,
                            start: "",
                            size: "medium"
                          }, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                              _createTextVNode("mdi-server")
                            ])),
                            _: 1,
                            __: [5]
                          }))
                        : (_ctx.isMulti)
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 6,
                              start: "",
                              size: "medium"
                            }, {
                              default: _withCtx(() => _cache[6] || (_cache[6] = [
                                _createTextVNode("mdi-text-box-multiple-outline")
                              ])),
                              _: 1,
                              __: [6]
                            }))
                          : (_ctx.isRouter)
                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                key: 7,
                                start: "",
                                size: "medium"
                              }, {
                                default: _withCtx(() => _cache[7] || (_cache[7] = [
                                  _createTextVNode("mdi-routes")
                                ])),
                                _: 1,
                                __: [7]
                              }))
                            : (_ctx.isRequest)
                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 8,
                                  start: "",
                                  size: "medium"
                                }, {
                                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                                    _createTextVNode("mdi-cloud-arrow-down-outline")
                                  ])),
                                  _: 1,
                                  __: [8]
                                }))
                              : (_ctx.isDatabase)
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 9,
                                    start: "",
                                    size: "medium"
                                  }, {
                                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                                      _createTextVNode("mdi-database")
                                    ])),
                                    _: 1,
                                    __: [9]
                                  }))
                                : (_ctx.isExtRequest)
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 10,
                                      start: "",
                                      size: "medium"
                                    }, {
                                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                                        _createTextVNode("mdi-cloud-arrow-up-outline")
                                      ])),
                                      _: 1,
                                      __: [10]
                                    }))
                                  : (_ctx.isDocs)
                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                        key: 11,
                                        start: "",
                                        size: "medium"
                                      }, {
                                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                                          _createTextVNode("mdi-file-document-outline")
                                        ])),
                                        _: 1,
                                        __: [11]
                                      }))
                                    : (_ctx.isCode)
                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 12,
                                          start: "",
                                          size: "medium"
                                        }, {
                                          default: _withCtx(() => _cache[12] || (_cache[12] = [
                                            _createTextVNode("mdi-code-braces")
                                          ])),
                                          _: 1,
                                          __: [12]
                                        }))
                                      : (_ctx.isConfig)
                                        ? (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 13,
                                            start: "",
                                            size: "medium"
                                          }, {
                                            default: _withCtx(() => _cache[13] || (_cache[13] = [
                                              _createTextVNode("mdi-cog-outline")
                                            ])),
                                            _: 1,
                                            __: [13]
                                          }))
                                        : (_ctx.isMagic)
                                          ? (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 14,
                                              start: "",
                                              size: "medium"
                                            }, {
                                              default: _withCtx(() => _cache[14] || (_cache[14] = [
                                                _createTextVNode("mdi-magic-staff")
                                              ])),
                                              _: 1,
                                              __: [14]
                                            }))
                                          : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.label), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["color"]))
}